import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import RefreshIcon from "@material-ui/icons/Refresh";
import { FunctionComponent, Suspense, lazy, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCheckPermissionQuery, useIsLoggedInQuery } from "../../graphql/generated/graphql";
import { ServiceWorkerState } from "../../shared/Hooks/useServiceWorker";
import Layout from "../../shared/LayoutWithTranslations";
import { PARTNER_PORTAL_TOUR_TARGETS } from "../../shared/PartnerPortalTourTargets";
import PermissionKeys from "../../shared/PermissionKeys";
import FeatureTipsTour from "../PartnerPortal/FeatureTipsTour";
import Home from "./index";

const HelpDialog = lazy(() => import(/* webpackChunkName: "partner-portal-module" */ "../PartnerPortal/Help"));

interface HomeWithLayoutProps
{
  appConfig: { env: string };
  serviceWorkerState: ServiceWorkerState;
}

const HomeWithLayout: FunctionComponent<HomeWithLayoutProps> = ({ appConfig, serviceWorkerState }) =>
{
  const { t } = useTranslation();
  const [isHelpDialogOpen, setIsHelpDialogOpen] = useState(false);
  const [featureTipsRestartSignal, setFeatureTipsRestartSignal] = useState(0);
  const { data: isLoggedInData } = useIsLoggedInQuery();

  const { data: checkWarehouseModulePermissionData, loading } = useCheckPermissionQuery({
    skip: !isLoggedInData?.isLoggedIn,
    variables: { PermissionKey: PermissionKeys.Warehouse.PWAModule }
  });

  const isPartnerPortalContext = isLoggedInData?.isLoggedIn === true && checkWarehouseModulePermissionData?.CheckPermission !== true;
  const hasWarehousePermission = checkWarehouseModulePermissionData?.CheckPermission === true;

  const partnerPortalMenuItems = isPartnerPortalContext ? (closeMenu: () => void) => ([
    <MenuItem key="partner-portal-help" onClick={() => { closeMenu(); setIsHelpDialogOpen(true); }} data-tour-id={PARTNER_PORTAL_TOUR_TARGETS.helpMenuItem}>
      <ListItemIcon>
        <HelpOutlineIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText primary={t('partnerPortal.help.menu')} />
    </MenuItem>,
    <MenuItem key="partner-portal-restart-tips" onClick={() => { closeMenu(); setFeatureTipsRestartSignal(value => value + 1); }}>
      <ListItemIcon>
        <RefreshIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText primary={t('partnerPortal.help.tipsMenu')} />
    </MenuItem>
  ]) : undefined;

  return (
    <>
      <Layout env={appConfig.env} serviceWorkerState={serviceWorkerState} menuItems={partnerPortalMenuItems}>
        <Home isLoggedIn={isLoggedInData?.isLoggedIn ?? false} hasWarehousePermission={hasWarehousePermission} loading={loading} />
      </Layout>
      {isPartnerPortalContext ? <FeatureTipsTour restartSignal={featureTipsRestartSignal} /> : null}
      <Suspense fallback={null}>
        <HelpDialog open={isHelpDialogOpen} onClose={() => setIsHelpDialogOpen(false)} />
      </Suspense>
    </>
  );
};

export default HomeWithLayout;
